export default {
    crucibleMudSocketUri: process.env.REACT_APP_SOCKET_URI
};



// WEBPACK FOOTER //
// ./src/config.js